<template>
  <small-modal class="expanded-modal" @close="closeModal">
    <div class="main-wrapper">
      <h1 class="title">Funnel</h1>
      <p class="subtitle">
        To adjust the period, exit this modal and pick dates from the top-left
        calendar.
      </p>
      <div class="funnel-wrapper">
        <DashboardFunnel
          :is-expanded="true"
          :segment-data-input="segmentDataInput"
        />
      </div>
    </div>
  </small-modal>
</template>

<script>
import SmallModal from "@/components/shared/SmallModal.vue";
import DashboardFunnel from "./DashboardFunnel.vue";

export default {
  components: {
    SmallModal,
    DashboardFunnel,
  },
  props: {
    segmentDataInput: { type: Array, required: true },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss">
.expanded-modal .small-modal.bigger {
  width: 90vw;
  max-width: 90vw;
  height: 90vh;
  max-height: 90vh;
  overflow: hidden;
}
</style>

<style lang="scss" scoped>
.main-wrapper {
  padding: 32px;
}

.title {
  @include base-font;
  @include font-big;
  font-weight: 600;
  margin-bottom: 12px;
}
.subtitle {
  @include base-font;
  @include font-normal;
  margin-bottom: 24px;
}

.funnel-wrapper {
  border: 6px solid $dark-purple;
  border-radius: 8px;
  padding: 24px 0;
}
</style>
